import { PureComponent } from 'react'
import PropTypes from 'prop-types'

import { withTranslation } from '../../i18n'
import { Container, ItemLink, TimeItemLink } from './styles'


const yearAndMonth = '2023-06' //NOTE: дата в формате YYYY-MM
const dayOfFestival = 23 //NOTE: Число, чтобы можно было прибавить день

const times = {
  '15': '15:00',
  '16': '16:00',
  '17': '17:00',
  '18': '18:00',
  '19': '19:00',
  '20': '20:00',
  '21': '21:00',
  '22': '22:00',
  '23': '23:00',
  '00': '00:00',
  '01': '01:00',
  '02': '02:00',
  '03': '03:00'
}

const timeFilters = [
  { label: times['15'], value: `datetime=${yearAndMonth}-${dayOfFestival}T${times['15']}:00.000Z` },
  { label: times['16'], value: `datetime=${yearAndMonth}-${dayOfFestival}T${times['16']}:00.000Z` },
  { label: times['17'], value: `datetime=${yearAndMonth}-${dayOfFestival}T${times['17']}:00.000Z` },
  { label: times['18'], value: `datetime=${yearAndMonth}-${dayOfFestival}T${times['18']}:00.000Z` },
  { label: times['19'], value: `datetime=${yearAndMonth}-${dayOfFestival}T${times['19']}:00.000Z` },
  { label: times['20'], value: `datetime=${yearAndMonth}-${dayOfFestival}T${times['20']}:00.000Z` },
  { label: times['21'], value: `datetime=${yearAndMonth}-${dayOfFestival}T${times['21']}:00.000Z` },
  { label: times['22'], value: `datetime=${yearAndMonth}-${dayOfFestival}T${times['22']}:00.000Z` },
  { label: times['23'], value: `datetime=${yearAndMonth}-${dayOfFestival}T${times['23']}:00.000Z` },
  { label: times['00'], value: `datetime=${yearAndMonth}-${dayOfFestival + 1}T${times['00']}:00.000Z` },
  { label: times['01'], value: `datetime=${yearAndMonth}-${dayOfFestival + 1}T${times['01']}:00.000Z` },
  { label: times['02'], value: `datetime=${yearAndMonth}-${dayOfFestival + 1}T${times['02']}:00.000Z` }
]
class FilterMenu extends PureComponent {
  static propTypes = {
    onChange: PropTypes.func,
    value: PropTypes.string.isRequired,
    items: PropTypes.arrayOf(PropTypes.object),
    t: PropTypes.func.isRequired,
    hasTimes: PropTypes.bool,
    datetime: PropTypes.string
  }

  static defaultProps = {
    onChange: () => {},
    items: [],
    hasTimes: false,
    datetime: undefined
  }

  selectItem = (selectedValue) => {
    this.props.onChange(selectedValue)
  }

  render() {
    const {
      value, t, items, hasTimes, datetime
    } = this.props
    return (
      <Container>
        {items.map(item => (
          <ItemLink key={item.label} onClick={() => this.selectItem(item.value)} selected={value === item.value}>
            {t(item.label)}
          </ItemLink>
        ))}
        {hasTimes && (
          <div className="timeItems">
            {timeFilters.map(timeItem => (
              <TimeItemLink
                key={timeItem.label}
                onClick={() => this.selectItem(timeItem.value)}
                selected={datetime && datetime !== '' && timeItem.value.endsWith(datetime)}
              >
                <div className="label">{timeItem.label}</div>
              </TimeItemLink>
            ))}
          </div>
        )}
      </Container>
    )
  }
}

export default withTranslation(['common'])(FilterMenu)
